<template>
  <basic-container style="margin: 0; padding: 0; height: 100%">
    <div class="path-container" style="margin-bottom: 20px; padding: 10px 15px; border-radius: 4px">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>客服工作站</el-breadcrumb-item>
        <el-breadcrumb-item>设备管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <avue-crud
      :option="option"
      :data="data"
      ref="crud"
      v-model="form"
      :permission="permissionList"
      @row-del="rowDel"
      @row-update="rowUpdate"
      @row-save="rowSave"
      :before-open="beforeOpen"
      :page.sync="page"
      @refresh-change="refreshChange"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @on-load="page => onLoad(page, params)"
      :row-style="rowStyle"
      :cell-style="cellStyle"
      :header-cell-class-name="headerCellClassName"
    >
      <template slot="menuLeft"></template>
      <template slot-scope="scope" slot="firstBind">
        <el-button type="text" size="small" @click="archiveType1(scope.row)" :style="scope.row.firstBind === 0 ? { color: 'red' } : scope.row.firstBind === 1 ? { color: 'black' } : {}">
          <!-- 未完成 -->
          {{ scope.row.firstBind === 1 ? '已完成' : '未完成' }}
        </el-button>
      </template>
      <template slot-scope="scope" slot="newDate">
        <el-button type="text" size="small" @click="toDataDetail(scope.row)">
          {{ scope.row.newDate }}
        </el-button>
      </template>
      <template slot="menu" slot-scope="{ row, index }">
        <el-button type="text" size="small" @click="view(row, index)" v-if="row.isNew == 0">确认查看</el-button>
        <el-button type="text" size="small" @click="toDataDetail(row, index)">查看详情</el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { getDetail, submit, remove, enable, disable } from '@/api/health/userjk'
import { getDeviceDetails, view } from '@/api/health/manage'
import { mapGetters } from 'vuex'
import func from '@/util/func'

export default {
  data() {
    return {
      params: {
        // channel: window.localStorage.getItem("channel"),
      },
      channel: window.localStorage.getItem('channel'),
      form: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      selectionList: [],
      headerCellClassName: 'headerClass',
      option: {
        indexLabel: '序号',
        tip: false,
        border: false,
        index: true,
        viewBtn: false,
        editBtn: false,
        addBtn: false,
        delBtn: false,
        selection: true,
        menuWidth: 100, // 初始宽度
        column: [
          {
            label: '当前用户',
            prop: 'name',
            search: true,
            width: 120,
            searchSpan: 4,
            searchValue: '',
            type: 'select', // 使用select组件，通常支持filterable
            addDisplay: true,
            editDisabled: false,
            dicUrl: 'https://dbadmin.dbzdjk.com/admin/manage/getName',
            dicQuery: {
              channel: window.localStorage.getItem('channel') === '大白主动健康' ? null : window.localStorage.getItem('channel')
            },
            dicMethod: 'get',
            props: {
              label: 'name',
              value: 'name'
            },
            filterable: true, // 启用过滤功能
            clearable: true, // 可清空
            placeholder: '请输入 姓名',
            slot: true
          },
          {
            label: '设备类型',
            prop: 'type',
            search: true,
            type: 'select',
            dicData: [
              { label: '复云手表', value: '复云手表' },
              { label: 'MW016 4G', value: 'MW016 4G' },
              { label: 'BT01', value: 'BT01' },
              // { label: "蓝牙设备", value: "蓝牙设备" },
              { label: 'GJ-SH-11 06C1', value: 'GJ-SH-11 06C1' },
              { label: 'ER08 1D59', value: 'ER08 1D59' }
            ],
            width: 120,
            searchSpan: 4
          },
          {
            label: '设备ID',
            prop: 'sn',
            search: true,
            width: 200,
            searchSpan: 4
          },
          {
            label: '绑定时间',
            prop: 'bindTime',
            searchSpan: 4,
            overHidden: true
          },
          {
            label: '首次绑定',
            prop: 'firstBind',
            search: true,
            type: 'select',
            overHidden: true,
            dicData: [
              { label: '未完成', value: 0 },
              { label: '已完成', value: 1 }
            ],
            width: 120,
            searchSpan: 4
          },
          {
            label: '电量',
            prop: 'elec',
            // search: true
            width: 70
          },
          // {
          //   label: '用户渠道',
          //   prop: 'channel',
          //   search: true,
          //   type: 'select',
          //   dicData: [
          //     { label: '大白主动健康', value: '大白主动健康' },
          //     { label: '大白乐康', value: '大白乐康' },
          //     { label: '永诚保险', value: '永诚保险' },
          //     { label: '泰山社区卫生服务中心', value: '泰山社区卫生服务中心' },
          //     { label: '南钢集团', value: '南钢集团' },
          //     { label: '中国石化集团共享服务有限公司南京分公司工会', value: '中国石化集团共享服务有限公司南京分公司工会' }
          //   ],
          //   width: 120
          // },
          {
            label: '最新健康数据时间',
            prop: 'newDate',
            overHidden: true
          },
          {
            label: '血压校准时间',
            prop: 'bpDate',
            overHidden: true
            // search: true
          }
        ]
      },
      data: []
    }
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.permission.health_userjk_add,
        viewBtn: this.permission.health_userjk_view,
        delBtn: this.permission.health_userjk_delete,
        editBtn: this.permission.health_userjk_edit
      }
    },
    ids() {
      const ids = []
      this.selectionList.forEach(ele => {
        ids.push(ele.id)
      })
      return ids.join(',')
    }
  },
  beforeRouteLeave(to, from, next) {
    const state = {
      params: { ...this.params },
      page: { ...this.page }
    }
    sessionStorage.setItem('equipment', JSON.stringify(state))
    next()
  },
  methods: {
    onLoad(page, params) {
      const savedState = sessionStorage.getItem('equipment')
      if (savedState) {
        const state = JSON.parse(savedState)
        page = state.page
        params = state.params
        this.page = state.page
        this.params = state.params
        this.option.column[0].searchValue = params.name
        this.option.column[1].searchValue = params.type
        this.option.column[2].searchValue = params.sn
        this.option.column[4].searchValue = params.firstBind
        this.option.column[6].searchValue = params.channel
        sessionStorage.removeItem('equipment')
      }

      // 渠道参数
      params.channel = window.localStorage.getItem("channel");

      getDeviceDetails(page.currentPage, page.pageSize, params).then(res => {
        const wxUserId = window.localStorage.getItem('pcUserId');
        if (wxUserId === '2043870969731301377' && res.data.devices.length > 0) {
          res.data.devices.forEach(item => {
              // item.mobile = func.maskPhone(item.mobile);
              item.name = func.maskName(item.name);
          });
        }
        this.data = res.data.devices
        this.page.total = res.data.total
        console.log('data:', this.data)
      })
      if (this.timer == null) {
        this.startTimer()
      }
    },

    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (column.property === 'firstBind' && row.firstBind === 1) {
        return {
          color: 'red'
        }
      }
    },

    archiveType1(row) {
      const parameter = {
        wxUserId: row.wxUserId
      }
      this.$router.push({
        path: '/customer/firstbinding',
        query: parameter
      })
    },

    archiveType2(row) {
      const parameter = {
        wxUserId: row.wxUserId
      }
      this.$router.push({
        path: '/customer/latesthealthdata',
        query: parameter
      })
    },

    searchChange(params, done) {
      // params.channel = window.localStorage.getItem("channel");
      this.params = params
      this.page.currentPage = 1
      this.onLoad(this.page, params)
      done()
    },

    rowSave(row, done, loading) {
      submit(row)
        .then(() => {
          done()
          this.onLoad(this.page)
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
        })
        .catch(() => {
          loading()
        })
    },

    rowUpdate(row, index, done, loading) {
      submit(row)
        .then(() => {
          done()
          this.onLoad(this.page)
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
        })
        .catch(() => {
          loading()
        })
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          return remove(row.id)
        })
        .then(() => {
          this.onLoad(this.page)
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
        })
    },

    searchReset() {
      this.params = {
        // channel: window.localStorage.getItem("channel"),
      }
      this.page.currentPage = 1
      this.onLoad(this.page, this.params)
    },

    selectionChange(list) {
      this.selectionList = list
    },

    refreshChange(data) {
      this.onLoad(this.page, data.searchForm)
    },

    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据')
        return
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          return remove(this.ids)
        })
        .then(() => {
          this.onLoad(this.page)
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
          this.$refs.crud.toggleSelection()
        })
    },
    handleEnable() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据')
        return
      }
      this.$confirm('确定对该用户启用VIP嘛?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          return enable(this.ids)
        })
        .then(() => {
          this.onLoad(this.page)
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
          this.$refs.crud.toggleSelection()
        })
    },
    handleDisable() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据')
        return
      }
      this.$confirm('确定对该用户停用VIP嘛?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          return disable(this.ids)
        })
        .then(() => {
          this.onLoad(this.page)
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
          this.$refs.crud.toggleSelection()
        })
    },

    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail(this.form.id).then(res => {
          this.form = res.data
        })
      }
      done()
    },

    archiveType(row) {
      const parameter = {
        wxUserId: row.wxUserId
      }
      this.$router.push({
        path: '/health/archiveType',
        query: parameter
      })
    },

    handleDetail(data) {
      this.$router.push({
        path: '/health/bpmeterdata_detail',
        query: {
          wxUserId: data.id,
          meterDate: this.params.meterDate,
          jkStatus: data.jkStatus
        }
      })
    },

    datashow(row) {
      const parameter = {
        wxUserId: row.wxUserId
      }
      this.$router.push({
        path: '/customer/datashow',
        query: parameter
      })
    },

    rowStyle({ row, rowIndex }) {
      if (row.isNew === '0') {
        return {
          color: '#1890ff'
        }
      }
    },

    view(row, index) {
      view(row.wxUserId).then(res => {
        this.onLoad(this.page)
      })
    },

    myTask() {
      getDeviceDetails(this.page.currentPage, this.page.pageSize, this.params).then(res => {
        this.data = res.data.devices
        this.page.total = res.data.total
      })
    },

    startTimer() {
      if (this.timer) clearInterval(this.timer)
      this.timer = setInterval(this.myTask, 30000)
    },

    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },

    beforeDestroy() {
      this.stopTimer()
    },

    toDataDetail(row, index) {
      const parameter = {
        wxUserId: row.wxUserId,
        imei: row.sn
      }
      this.$router.push({
        path: '/customer/dataDetail',
        query: parameter
      })
    }
  }
}
</script>
<style lang="scss">
.headerClass {
  background-color: #409eff !important;
  color: #fff !important;
}
</style>
